import { createAsyncThunk } from "@reduxjs/toolkit";
import { decreaseBpCount, increaseBpCount } from "../../directories/directories.slice";
import { organizationAPI } from "libs/apiClient/Organization";
import { snackWrapper } from "helpers";

export const getProcesses = createAsyncThunk(
	"stepTwoSlice/getProcesses",
	async (organizationId: number, { rejectWithValue }) => {
		try {
			return await organizationAPI.processesDetail(organizationId).then(({ data }) => data);
			// return (await $api<any>(`/organization/${organizationId}/processes`)).data;
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const createProcess = createAsyncThunk(
	"stepTwoSlice/createProcess",
	async (
		{ organizationId, process, close }: { organizationId: number; process: any; close: () => void },
		{ rejectWithValue, dispatch },
	) => {
		try {
			const newProcess = await organizationAPI
				.processCreate(organizationId, {
					clazz: process.clazz.id,
					criticality: process.isCriticality,
					defense: process.isDefense,
					ecologic: process.isEcologic,
					economic: process.isEconomic,
					name: process.name,
					politic: process.isPolitic,
					reason: process.reason,
					sequenceNumber: process.sequenceNumber,
					shortDescription: process.shortDescription,
					social: process.isSocial,
				})
				.then(({ data }) => data);
			// const newProcess = (
			// 	await $api.post<any>(`/organization/${organizationId}/process`, {
			// 		clazz: process.clazz.id,
			// 		criticality: process.isCriticality,
			// 		defense: process.isDefense,
			// 		ecologic: process.isEcologic,
			// 		economic: process.isEconomic,
			// 		name: process.name,
			// 		politic: process.isPolitic,
			// 		reason: process.reason,
			// 		sequenceNumber: process.sequenceNumber,
			// 		shortDescription: process.shortDescription,
			// 		social: process.isSocial,
			// 	})
			// ).data;
			dispatch(increaseBpCount(newProcess.clazz.id));
			close();
			return newProcess;
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const editProcess = createAsyncThunk(
	"stepTwoSlice/editProcess",
	async ({ process, close }: { process: any; close: () => void }, { rejectWithValue }) => {
		try {
			const response = await organizationAPI
				.processCreate2(process.id, {
					clazz: process.selectedClass,
					criticality: process.isCriticality,
					defense: process.isDefense,
					ecologic: process.isEcologic,
					economic: process.isEconomic,
					name: process.name,
					politic: process.isPolitic,
					reason: process.reason,
					sequenceNumber: process.sequenceNumber,
					shortDescription: process.shortDescription,
					social: process.isSocial,
				})
				.then(({ data }) => data);
			// const response = (
			// 	await $api.post<any>(`/organization/process/${process.id}`, {
			// 		clazz: process.selectedClass,
			// 		criticality: process.isCriticality,
			// 		defense: process.isDefense,
			// 		ecologic: process.isEcologic,
			// 		economic: process.isEconomic,
			// 		name: process.name,
			// 		politic: process.isPolitic,
			// 		reason: process.reason,
			// 		sequenceNumber: process.sequenceNumber,
			// 		shortDescription: process.shortDescription,
			// 		social: process.isSocial,
			// 	})
			// ).data;
			close();
			return response;
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const deleteProcess = createAsyncThunk(
	"stepTwoSlice/deleteProcess",
	async (process: any, { rejectWithValue, dispatch }) => {
		try {
			await organizationAPI.processDelete(process.id);
			// await $api.delete<any>(`/organization/process/${process.id}`);
			dispatch(decreaseBpCount(process.clazz.id));
			return process.id;
		} catch (error: any) {
			snackWrapper("error", error.response.data);
		}
	},
);

export const getProcessConnection = createAsyncThunk(
	"stepTwoSlice/getProcessConnection",
	async (
		{
			organizationId,
			processId,
			setLoading,
		}: { organizationId: number; processId: number; setLoading: (value: boolean) => void },
		{ rejectWithValue },
	) => {
		try {
			const response = await organizationAPI.processObjectsDetail(organizationId, processId).then(({ data }) => data);
			// const response = (await $api<any[]>(`/organization/${organizationId}/process/${processId}/objects`)).data;
			setLoading(false);
			return response;
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const editProcessConnection = createAsyncThunk(
	"stepTwoSlice/editProcessConnection",
	async (
		{
			organizationId,
			processId,
			connection,
			all
		}: { organizationId: number; processId: number;all:boolean|null; connection: any[]; },
		{ rejectWithValue },
	) => {
		try {
			return await organizationAPI
				.processObjectCreate(organizationId, processId, {
					list: all === null ?connection:null,
					all
				})
				.then(({ data }) => data);
			// return (
			// 	await $api.post<any[]>(`/organization/${organizationId}/process/${processId}/object`, {
			// 		list: connection,
			// 		author: author,
			// 	})
			// ).data;
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const dowloadDocument = createAsyncThunk(
	"stepTwoSlice/dowloadDocument",
	async ({ orgId }: { orgId: number }, { rejectWithValue }) => {
		try {
			return await organizationAPI.processesDocDetail(orgId, { format: "blob" }).then((response) => {
				const fileName = decodeURI(response.headers["content-disposition"]?.split("filename=")[1] || "");
				const href = URL.createObjectURL(response.data);
				const link = document.createElement("a");
				link.href = href;
				link.setAttribute("download", fileName || "file.docx");
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				URL.revokeObjectURL(href);
			});
			// return $api({
			// 	url: `/organization/${orgId}/processes/doc`, //your url
			// 	method: "GET",
			// 	responseType: "blob", // important
			// }).then((response) => {
			// 	console.log(response);
			// 	const fileName = decodeURI(response.headers["content-disposition"]?.split("filename=")[1] || "");
			// 	const href = URL.createObjectURL(response.data);
			// 	const link = document.createElement("a");
			// 	link.href = href;
			// 	link.setAttribute("download", fileName || "file.docx");
			// 	document.body.appendChild(link);
			// 	link.click();
			// 	document.body.removeChild(link);
			// 	URL.revokeObjectURL(href);
			// });
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const uploadDocument = createAsyncThunk(
	"stepTwoSlice/uploadDocument",
	async ({ orgId, file }: { orgId: number; file: any }, { rejectWithValue }) => {
		try {
			// const params = new FormData();
			// params.append("file", file);
			await organizationAPI.processesDocCreate(orgId, { file });
			// await $api.post<any>(`/organization/${orgId}/processes/doc`, params);
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const printDocument = createAsyncThunk(
	"stepTwoSlice/printDocument",
	async ({ orgId }: { orgId: number }, { rejectWithValue }) => {
		try {
			return await organizationAPI.processesDocPrintDetail(orgId, { format: "blob" }).then(async (response: any) => {
				const clear = (frame: HTMLIFrameElement) => {
					frame.remove();
				};
				let blob = new Blob([response.data], { type: response.data.type }); //this make the magic
				let blobURL = URL.createObjectURL(blob);
				const frames = document.querySelectorAll("iframe");
				frames.forEach((_) => {
					clear(_);
				});
				let iframe: HTMLIFrameElement = document.createElement("iframe"); //load content in an iframe to print later
				document.body.appendChild(iframe);
				iframe.style.display = "none";
				iframe.src = blobURL;
				iframe.onload = function () {
					setTimeout(function () {
						iframe.focus();
						iframe.contentWindow!.print();
					}, 1);
				};
			});
			// return $api({
			// 	url: `${`/organization/${orgId}/processes/doc/print`}`, //your url
			// 	method: "GET",
			// 	responseType: "blob", // important
			// }).then(async (response: any) => {
			// 	const clear = (frame: HTMLIFrameElement) => {
			// 		frame.remove();
			// 	};
			// 	let blob = new Blob([response.data], { type: response.data.type }); //this make the magic
			// 	let blobURL = URL.createObjectURL(blob);
			// 	const frames = document.querySelectorAll("iframe");
			// 	frames.forEach((_) => {
			// 		clear(_);
			// 	});
			// 	let iframe: HTMLIFrameElement = document.createElement("iframe"); //load content in an iframe to print later
			// 	document.body.appendChild(iframe);
			// 	iframe.style.display = "none";
			// 	iframe.src = blobURL;
			// 	iframe.onload = function () {
			// 		setTimeout(function () {
			// 			iframe.focus();
			// 			iframe.contentWindow!.print();
			// 		}, 1);
			// 	};
			// });
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);
